import React from 'react'
import PropTypes from 'prop-types'
import EditImg from 'src/assets/img/house/btn_profile.png'

export const EditProfileButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="absolute bottom-0 right-0 w-5 h-5 xs:h-7 xs:w-7 cursor-pointer hover:scale-105 transition-transform"
    >
      <img src={EditImg} alt="Edit" className="w-full h-full object-contain" />
    </button>
  )
}

EditProfileButton.propTypes = {
  onClick: PropTypes.func
}
